import { ComponentProps, forwardRef } from 'react';

import { OptionList, Select, SimpleSelectTrigger } from '@ingrid/luterkort-react';

type SelectRootProps = ComponentProps<typeof Select.Root>;

export type SimpleSelectProps = {
  renderOptionLabel?: (option: [string, string], index: number) => JSX.Element;
  options: [string, string][];
  'data-testid'?: string;
  placeholder?: string;
  invalid?: boolean;
} & SelectRootProps;

export const SimpleSelect = forwardRef<HTMLButtonElement, SimpleSelectProps>(function SimpleSelect(props, ref) {
  const { renderOptionLabel, invalid, placeholder, options, ...rootProps } = props;

  return (
    <Select.Root {...rootProps}>
      <Select.Trigger data-invalid={invalid} data-testid={rootProps['data-testid']} ref={ref}>
        <SimpleSelectTrigger options={options} placeholder={placeholder ?? ''} />
      </Select.Trigger>

      <Select.Content>
        <OptionList.Viewport>
          {options.map(([value, label], index) => (
            <OptionList.Item key={value} value={value}>
              <OptionList.ItemText>
                {renderOptionLabel ? renderOptionLabel([value, label], index) : label}
              </OptionList.ItemText>
              <OptionList.ItemIndicator />
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </Select.Content>
    </Select.Root>
  );
});
